import { render } from "./ParagraphsNew.vue?vue&type=template&id=247662b2"
import script from "./ParagraphsNew.vue?vue&type=script&lang=js"
export * from "./ParagraphsNew.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__